import { PaymentDetails } from "../../services/payments/dto/payment-details-response-dto";
import { PaymentResponse } from "../../services/payments/dto/payment-intent-response-dto";
import dayjs, { Dayjs } from '../../utils/dayjs';

export type PaymentStatus =  'CREATED' | 'PENDING' | 'PROCESSING' | 'PAID' | 'CANCELLED' | 'REFUNDED';

export class Intent {
  uuid: string;
  name: string;
  status: PaymentStatus;
  qrCode?: string;
  timeoutInMinutes: number;
  createdAt: Dayjs;
  endDate: Dayjs;

  constructor(paymentIntent: PaymentResponse | PaymentDetails, timezone: string = 'America/Sao_Paulo') {
    this.uuid = paymentIntent.uuid;
    this.name = paymentIntent.name;
    this.status = paymentIntent.status;
    this.qrCode = paymentIntent.qrCode ?? '';
    this.timeoutInMinutes = paymentIntent.timeoutMinutes;
    this.createdAt = dayjs(paymentIntent.createdAt).tz(timezone).utc();
  }
  
  calculateEndDate(timezone: string = 'America/Sao_Paulo') {
    this.endDate = dayjs(this.createdAt.format()).tz(timezone).add(this.timeoutInMinutes, 'minute').utc();
  }

  getDiff(timezone: string = 'America/Sao_Paulo') {
    const now = dayjs().tz(timezone).utc();
    return this.endDate.diff(now, 'second');
  }
}
